import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SearchFormBase } from '../../../../../components/common/search-form-base/search-form-base';
import { SortHelper } from '../../../../../components/common/sort-helper/sort-helper';
import { AppServiceHelperService } from '../../../../../services/app-service-helper.service';
import { EventBusService } from '../../../../../services/event-bus.service';
import { AppStorageService } from '../../../../../services/app-storage.service';

/**
 * Projects search form
 */
@Component({
  selector: 'projects-search-form',
  templateUrl: './projects-search-form.component.html',
  styleUrls: ['./projects-search-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectsSearchFormComponent extends SearchFormBase<any> implements OnInit {
  /**
   * Search event name (event bus)
   */
  protected get searchEventName(): string {
    return 'project.valuation.projectstd.search';
  }

  /**
   * Show all event name (event bus)
   */
  protected get showAllEventName(): string {
    return 'project.valuation.projectstd.showAll';
  }

  /**
   *
   * Gets the filter object
   * @param form
   * @returns
   */
  protected getFilterObject(form: UntypedFormGroup) {
    const filter = {
      logic: "and",
      filters: [],
      serverFilters: []
    };

    this.addFilter(filter, form, 'puid', 'Oid', 'contains');
    this.addFilter(filter, form, 'projectName', 'Name', 'contains');
    this.addFilter(filter, form, 'projectStatus', 'ProjectPhaseValuationId', 'contains');
    this.addFilter(filter, form, 'client', 'ClientManual', 'contains');
    return filter;
  }

  /**
   * Creates the FormGroup
   * @param data
   * @returns
   */
  protected createFormGroup(data: any): UntypedFormGroup {
    return new UntypedFormGroup({
      puid: new UntypedFormControl(data.puid),
      projectName: new UntypedFormControl(data.projectName),
      client: new UntypedFormControl(data.client),
      projectStatus: new UntypedFormControl(data.projectStatus)
    });
  }

  /**
   * Resets the form
   */
  protected reset(): void {
    this.formData.controls['puid'].setValue('');
    this.formData.controls['projectName'].setValue('');
    this.formData.controls['projectStatus'].setValue(0);
    this.formData.controls['client'].setValue('');

    sessionStorage.removeItem('puid');
    sessionStorage.removeItem('projectName');
    sessionStorage.removeItem('projectStatus');
    sessionStorage.removeItem('client');

    this.appStorage.setSelectedProject(null);
    this.appStorage.setSelectedPortfolio(null);

    this.eventBus.broadcastEvent('hideParticipantsIcon', true);
  }

  /**
   * Initializes the form data
   * @returns
   */
  protected initFormData(): Promise<any> {
    return new Promise<any>((resolve) => {
      const values = { projectName: '', puid: null, projectStatus: 0, client: '' };
      values.projectName = sessionStorage.getItem('projectName');
      values.puid = sessionStorage.getItem('puid') ? Number(sessionStorage.getItem('puid')) : null;
      values.projectStatus = sessionStorage.getItem('projectStatus') ? parseInt(sessionStorage.getItem('projectStatus')) : 0;
      values.client = sessionStorage.getItem('client');
      resolve(values);
    });
  }

  /**
   *
   * Constructor
   * @param appStorage AppStorageService
   * @param eventBus EventBusService
   * @param httpClient HttpClient
   * @param appServiceHelper AppServiceHelperService
   */
  constructor(private appStorage: AppStorageService, eventBus: EventBusService, httpClient: HttpClient, appServiceHelper: AppServiceHelperService) {
    super(eventBus, httpClient, 'resetValuationSearchMode', appServiceHelper);
  }

  /**
   * Allows processing / filtering / sorting of reflists
   * @param reflistName The reflist name
   * @param reflistData The reflist data
   * @returns The filtered reflist data
   */
  protected processReflistResult(reflistName: string, reflistData: any[]): any[] {
    if (reflistName === 'ref_projectphasevaluation') {
      reflistData.sort(SortHelper.sortArrayBy('description'));
    }
    return reflistData;
  }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    this.requireReflist('ref_projectphasevaluation');
    this.init().then(() => {
      //Nothing
    });
  }
}
